export default __webpack_public_path__ + "static/media/rocket_launch.1e5bd952.png";